module.exports = __webpack_public_path__ + "img/Mstorybg303.06d24904.png";